<app-private-navbar></app-private-navbar> <!-- Navbar privata -->

<div class="private-layout">
  <main>
    <router-outlet></router-outlet>
  </main>
</div>
<app-footer></app-footer>